import * as ACTION_TYPES from './payrollActionTypes';

//payroll list filter
export const setPayrollListFilter = data => ({
	type: ACTION_TYPES.SET_PAYROLL_LIST_FILTER,
	payload: {
		data
	}
})